import {useListView} from '../../core/ListViewProvider'
import {CouponListSearchComponent} from './CouponListSearchComponent'
import { CouponListToolbar } from './CouponListToolbar'

const CouponListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* Search bar */}
      <CouponListSearchComponent />
       {/* begin::Card toolbar */}
       <div className='card-toolbar'>
        {/* begin::Group actions */}
         <CouponListToolbar /> 
        {/* end::Group actions */}
      </div>
    </div>
  )
}

export {CouponListHeader}
